import { CustomFlowbiteTheme } from "flowbite-react";

export const customTheme: CustomFlowbiteTheme = {
  button: {
    color: {
      primary:
        "text-white bg-primary-black focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-grayscale-contrast-30",
      "custom-gray":
        " text-grayscale-contrast-80 bg-grayscale-contrast-10 hover:shadow-[0_0_0_1px_var(--tw-shadow-color)] hover:shadow-grayscale-contrast-5 focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-grayscale-contrast-5",
      white:
        "bg-primary-white text-semantic-text-body hover:shadow-[0_0_0_1px_var(--tw-shadow-color)] hover:shadow-grayscale-contrast-5 focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-grayscale-contrast-5",
      green:
        "text-semantic-success-success-text bg-semantic-success-10 hover:bg-semantic-success-50 focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-semantic-success-10 focus:text-primary-white focus:bg-semantic-success-success-primary",
      red: "text-semantic-system-error-text bg-semantic-system-error-10 hover:bg-semantic-system-error-50 focus:bg-semantic-text-error-primary focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-semantic-system-error-10 focus:text-primary-white",
      primaryOutline:
        "text-semantic-text-body bg-primary-white shadow-[0_0_0_1px_var(--tw-shadow-color)] shadow-grayscale-contrast-80 hover:text-primary-white hover:bg-grayscale-contrast-30 hover:shadow-[0_0_0_1px_var(--tw-shadow-color)] hover:shadow-grayscale-contrast-5 focus:text-primary-white focus:bg-grayscale-contrast-80 focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-grayscale-contrast-30",
      grayOutline:
        "text-semantic-text-body bg-primary-white shadow-[0_0_0_1px_var(--tw-shadow-color)] shadow-grayscale-contrast-30 hover:bg-grayscale-contrast-30 hover:shadow-[0_0_0_1px_var(--tw-shadow-color)] hover:shadow-grayscale-contrast-5 focus:text-primary-white focus:bg-grayscale-contrast-80 focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-grayscale-contrast-20",
      transparentOutline:
        "text-semantic-text-body bg-transparent shadow-[0_0_0_1px_var(--tw-shadow-color)] shadow-grayscale-contrast-30 hover:text-primary-white hover:bg-grayscale-contrast-30 hover:shadow-[0_0_0_1px_var(--tw-shadow-color)] hover:shadow-grayscale-contrast-5 focus:text-primary-white focus:bg-grayscale-contrast-80 focus:shadow-[0_0_0_3px_var(--tw-shadow-color)] focus:shadow-grayscale-contrast-30",
      warning: "bg-semantic-warning-10",
    },
    disabled: "text-semantic-text-disabled bg-grayscale-contrast-20",
  },
  textInput: {
    field: {
      icon: {
        svg: "h-[12px] w-[12px] text-semantic-text-secondary",
      },
      rightIcon: {
        svg: "h-[10px] w-[10px]",
        base: "cursor-pointer pointer-events-auto absolute inset-y-0 right-0 flex items-center pr-3",
      },
      input: {
        colors: {
          gray: "text-primary-black border-semantic-divider bg-primary-white placeholder:text-semantic-text-tertiary focus:border-[1px] focus:border-primary-black focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-black dark:focus:ring-primary-black",
          white:
            "border-none bg-primary-white text-primary-black focus:outline-primary-white focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:outline-none dark:focus:ring-0",
        },
        withIcon: {
          on: "pl-[32px]",
          off: "",
        },
      },
    },
  },
  checkbox: {
    root: {
      base: "h-4 w-4 rounded border border-semantic-divider bg-primary-white focus:ring-0 dark:border-gray-600 dark:bg-gray-700",
      color: {
        dark: "checked:bg-primary-black",
      },
    },
  },
  tabs: {
    tablist: {
      tabitem: {
        base: "flex-1 items-center justify-center rounded-t-lg p-3 text-sm font-medium first:ml-0 focus:outline-none disabled:cursor-not-allowed disabled:text-semantic-text-secondary disabled:dark:text-gray-500",
        variant: {
          underline: {
            active: {
              on: "active rounded-t-lg border-b-[1px] border-primary-black text-primary-black dark:border-cyan-500 dark:text-cyan-500",
              off: "border-b-[1px] border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-600 dark:text-gray-400 dark:hover:text-gray-300",
            },
          },
        },
      },
    },
  },
  dropdown: {
    arrowIcon: "ml-2 mt-[2px] h-4 w-4 text-primary-black",
  },
  table: {
    body: {
      // base: "rounded-lg",
      cell: {
        base: "h-[54px] p-0 text-semantic-text-body",
      },
    },
    head: {
      base: "bg-grayscale-contrast-5 ",
      cell: {
        base: "h-[52px] p-0 text-semantic-text-secondary",
      },
    },
  },
  pagination: {
    pages: {
      base: "m-[16px] xs:mt-0 m-0 inline-flex items-center -space-x-px",
      selector: {
        base: "w-[33px] h-[34px] text-body-14 font-medium leading-body-14 whitespace-nowrap border border-gray-300 bg-white leading-tight text-semantic-text-tertiary enabled:hover:bg-gray-100 enabled:hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 enabled:dark:hover:bg-gray-700 enabled:dark:hover:text-white",
        active:
          "text-semantic-text-secondary hover:bg-cyan-100 hover:text-cyan-700 dark:border-gray-700 dark:bg-gray-700 dark:text-white",
        disabled: "cursor-not-allowed opacity-50",
      },
      previous: {
        base: "py-[6px] px-[12px] w-[44px] h-[34px] ml-0 rounded-l-lg border border-gray-300 bg-white leading-tight text-semantic-text-secondary enabled:hover:bg-gray-100 enabled:hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 enabled:dark:hover:bg-gray-700 enabled:dark:hover:text-white",
        icon: "h-[20px] w-[20px]",
      },
      next: {
        base: "py-[6px] px-[12px] w-[44px] h-[34px] rounded-r-lg border border-gray-300 bg-white leading-tight text-semantic-text-secondary enabled:hover:bg-gray-100 enabled:hover:text-gray-700 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 enabled:dark:hover:bg-gray-700 enabled:dark:hover:text-white",
        icon: "h-[20px] w-[20px]",
      },
    },
  },
  breadcrumb: {
    root: {
      // base: "pt-[16px] pb-[15px]",
      base: "pt-[16px]",
    },
  },
  fileInput: {
    field: {
      input: {
        colors: {
          black:
            "border-semantic-divider bg-primary-white text-primary-black focus:border-primary-black focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
          gray: "border-semantic-divider bg-primary-white text-semantic-text-disabled focus:border-primary-black focus:ring-cyan-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
        },
      },
    },
  },
  select: {
    field: {
      select: {
        colors: {
          black:
            "border-semantic-divider bg-primary-white text-primary-black focus:border-primary-black focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
          white:
            "border-none bg-primary-white text-primary-black focus:border-white focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-cyan-500 dark:focus:ring-cyan-500",
        },
      },
    },
  },
  radio: {
    root: {
      base: "flex checked:bg-primary-black checked:border-primary-black focus:ring-0",
    },
  },
  datepicker: {
    popup: {
      header: {
        base: "",
        title:
          "px-2 py-3 text-center font-semibold text-gray-900 dark:text-white",
        selectors: {
          base: "mb-2 flex justify-between",
          button: {
            base: "rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600",
            prev: "",
            next: "",
            view: "",
          },
        },
      },
      footer: {
        button: {
          today:
            "bg-primary-black text-white hover:bg-primary-black dark:bg-cyan-600 dark:hover:bg-cyan-700",
        },
      },
    },
    views: {
      days: {
        header: {
          title:
            "h-6 text-center font-semibold text-xs leading-[18px] text-semantic-text-secondary",
        },
        items: {
          item: {
            selected: "bg-primary-black text-white hover:bg-primary-black",
          },
        },
      },
    },
  },
  textarea: {
    base: "py-[12px] px-[16px] resize-none block w-full rounded-lg border-semantic-divider text-sm disabled:cursor-not-allowed disabled:opacity-50 text-primary-black border-semantic-divider bg-primary-white placeholder:text-semantic-text-tertiary focus:border-[1px] focus:border-primary-black focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-black dark:focus:ring-primary-black",
    colors: {
      gray: "text-primary-black border-semantic-divider bg-primary-white placeholder:text-semantic-text-tertiary focus:border-[1px] focus:border-primary-black focus:ring-0 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-primary-black dark:focus:ring-primary-black",
    },
  },
};
